import angular from 'angular';

export class ProductIncomeController {

  closeWindow: Function;

  data;
  options;
  model;

  /*@ngInject*/
  constructor($scope, Storage, WindowService) {
    this.Storage = Storage;
    this.scope   = $scope;

    this.closeWindow = WindowService.delItem;
  }

  $onInit() {
    this.model = {
      count: 0,
      productId: this.data.product._id,
      type: 'income',
      comment: ''
    };
  }

  save() {
    return this.Storage.saveMovement(this.model)
      .then(() => {
        this.close();
      })
      .catch(err => {
        console.error(err);
      });
  }

  close() {
    this.closeWindow(this.data.id);
  }
}



export default angular.module('storageApp.product.income', [])
  .component('productIncome', {
    bindings: {data: '='},
    template: require('./product-income.html'),
    transclude: true,
    controller: ProductIncomeController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/product-income/product-income.component.js